module.exports = __webpack_public_path__ + "static/media/datsaet-2.c11e4ceb.PNG";